import React from "react";
import styled from "styled-components";
import { Colors } from "../../../config";

const FlightDateTimeContainer = ({ time, date, place }) => {
  return (
    <StyledDateTime>
      <div>{time}</div>
      <div>
        {place} • {date}
      </div>
    </StyledDateTime>
  );
};

const StyledDateTime = styled.div`
  text-align: center;
  > div:first-child {
    font-size: 1.125rem;
    font-weight: 800;
  }
  > div:last-child {
    font-size: 0.6rem;
    color: ${Colors.greyAsh};
    font-weight: 600;
  }
`;

export default FlightDateTimeContainer;
